//#region ../../node_modules/@jwplayer/fe-common/module/types/index.js
/**
* Type guard for undefined types
*/
function isDefined(v) {
	return !(typeof v === "undefined");
}

//#endregion
export { isDefined };